exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-emailLayout-EmailLayoutPage-infoSection{-webkit-box-shadow:0 0 1px rgba(0,0,0,.5);box-shadow:0 0 1px rgba(0,0,0,.5);color:gray;border:2px solid #b3b3b3 !important;border-radius:0 !important}.src-components-emailLayout-EmailLayoutPage-preview{float:right;position:relative;margin-top:10px;z-index:10}.src-components-emailLayout-EmailLayoutPage-attachmentBlock{display:inline-block}", ""]);

// exports
exports.locals = {
	"infoSection": "src-components-emailLayout-EmailLayoutPage-infoSection",
	"preview": "src-components-emailLayout-EmailLayoutPage-preview",
	"attachmentBlock": "src-components-emailLayout-EmailLayoutPage-attachmentBlock"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/emailLayout/EmailLayoutPage/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/emailLayout/EmailLayoutPage/styles.scss
// module chunks = 1